(function($) {

	'use strict';

	var init = function() {

		$(window).resize(function() {
			initialize()
		}).resize()


        toggleActive()
	};

	var initialize = function() {
		if($(window).width() < 992) {
			$('.flex-tab__tab').css('padding-bottom', '0')
			$('.flex-tab__content').css('height', 'initial')
		} else {
			var maxHeight = 0
			$('.flex-tab__content').each(function() {
				var height = $(this).innerHeight()
				if(height > maxHeight) {
					maxHeight = height
				}
			});
			$('.flex-tab__button:first-child').addClass('flex-tab__button--active')
			$('.flex-tab__content:nth-child(2)').addClass('flex-tab__content--active')
			$('.flex-tab__tab').css('padding-bottom', maxHeight + 'px')
			$('.flex-tab__content').css('display', '')
			$('.flex-tab__content').css('height', maxHeight + 'px')
		}
	}
	
	var toggleActive = function() {

		var button = $('.flex-tab__button')

		button.click(function() {
			var tab = $('#' + $(this).data('id'))
			if(!$(this).hasClass('flex-tab__button--active')) {
				$('.flex-tab__button').removeClass('flex-tab__button--active')
				$('.flex-tab__content').removeClass('flex-tab__content--active')
				if($(window).width() < 992) {
					$('.flex-tab__content').slideUp(300)
				}
			}
			$(this).toggleClass('flex-tab__button--active')
			tab.toggleClass('flex-tab__content--active')
			if($(window).width() < 992) {
				tab.slideToggle(300)
				$(this).toggleClass('c')
				tab.toggleClass('flex-tab__content--active')
			} else {
				$(this).addClass('flex-tab__button--active')
				tab.addClass('flex-tab__content--active')
			}
		})

	}

	$(document).ready(function() {
        init();
	});

})(jQuery);
